import { Component, OnInit, inject, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms'; // Importa FormsModule
import { CommonModule, formatDate } from '@angular/common';
import { DomSanitizer, SafeResourceUrl   } from "@angular/platform-browser";
import { NgbDatepickerModule, NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormArray, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { ModalComponent } from "../../../modal/modal.component";
import { InicioService } from '../../../../services/inicio.service';
import { UsuarioService } from '../../../../services/usuario.service';
import { I18n, CustomDatepickerI18n } from '../../../../clases/idioma-fecha';
import { appsettings } from '../../../../settings/appsettings';

@Component({
  selector: 'app-editar',
  standalone: true,
  imports: [ModalComponent, CommonModule, FormsModule, NgbDatepickerModule, NgxMaskDirective, ReactiveFormsModule],
  templateUrl: './editar.component.html',
  styleUrl: './editar.component.css',
  providers: [
    provideNgxMask(),
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }
  ],
})
export class EditarComponent implements OnInit{

  @ViewChild(ModalComponent) mdl!: ModalComponent;
  @Input() id_estudiante?: any;
  @Input() nombre_participante?: any;
  @Output() vuelve = new EventEmitter<any>();
  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;
  user: any;
  errorMessage: string = '';

  cmbDiscapacidad: boolean = false;
  cmbGrupoEtnico: boolean = false;

  tieneHijo: boolean = false;
  etinico: boolean = false;
  tieneCertificado: boolean = false;
  valida_hijos: boolean = false;
  datosEstudiante: any = [];
  documentos: any = [];
  edad: number = 0;

  txtNotas: string = 'Cargar .PDF';
  txtConstancia: string = 'Cargar .PDF';
  txtFotografia: string = 'Cargar .PDF';
  txtCarnet: string = 'Cargar .PDF';
  txtCedula: string = 'Cargar .PDF';
  txtRepresentante: string = 'Cargar .PDF';
  txtSalud: string = 'Cargar .PDF';
  txtRif: string = 'Cargar .PDF';
  txtCurriculum: string = 'Cargar .PDF';
  txtReferencia: string = 'Cargar .PDF';
  txtLopna: string = 'Cargar .PDF';

  valNotas: SafeResourceUrl | null = null;
  valConstancia: SafeResourceUrl | null = null;
  valFotografia: SafeResourceUrl | null = null;
  valCarnet: SafeResourceUrl | null = null;
  valCedula: SafeResourceUrl | null = null;
  valRepresentante: SafeResourceUrl | null = null;
  valSalud: SafeResourceUrl | null = null;
  valRif: SafeResourceUrl | null = null;
  valCurriculum: SafeResourceUrl | null = null;
  valReferencia: SafeResourceUrl | null = null;
  valLopna: SafeResourceUrl | null = null;

  id_pais_re: string = '228';

  fliNotas: any = [];
  fliConstancia: any = [];
  fliFotografia: any = [];
  fliCarnet: any = [];
  fliCedula: any = [];
  fliRepresentante: any = [];
  fliSalud: any = [];
  fliRif: any = [];
  fliCurriculum: any = [];
  fliReferencia: any = [];
  fliLopna: any = [];


  arrOcupa: any | undefined;
  arrPais: any | undefined;
  arrEstado: any | undefined;
  arrOperadora: any | undefined;
  arrOperadoraMovil: any | undefined;
  arrMunicipio: any | undefined;
  arrParroquia: any | undefined;
  arrProgramaInces: any | undefined;
  arrGrupoEtnico: any | undefined;
  arrDiscapacidad: any | undefined;

  private srvLogin = inject(InicioService);
  private servicios = inject(UsuarioService);
  private sanitizer = inject(DomSanitizer);
  //private fb = inject(FormBuilder)
  private url = appsettings.apiUrl;

  formularioRegistro: FormGroup;

  constructor( private fb:FormBuilder ){
    this.formularioRegistro = this.fb.group({
        //--------Datos personales
        id_pais: ['', Validators.required],
        nro_doc: [''],
        documento: [''],
        nombre: ['', Validators.required],
        apellido: ['', Validators.required],
        genero: ['', Validators.required],
        fch_nacimiento: ['', Validators.required],
        edad: ['', Validators.required],
        edo_civil: ['', Validators.required],
        lugar_nacimiento: ['', Validators.required],
        tiene_hijos: [false],
        indique_hijos: [''],
        otros_hijos: [''],
        grupo_etnico: [false],
        indique_etnia: [''],
        discapacidad: [false],
        indique_discapacidad: [''],
        certificado_discapacidad: [false],
        tp_dis: [''],
        numero_discapacidad: [''],
        //--------Datos constacto
        pais_residencia: [this.id_pais_re],
        estado: ['', Validators.required],
        municipio: ['', Validators.required],
        parroquia: ['', Validators.required],
        ciudad: ['', Validators.required],
        sector: ['', Validators.required],
        direccion_residencia: ['', Validators.required],
        tipo_operadora: [''],
        tlf_local: [''],
        tipo_operadora_movil: ['', Validators.required],
        tlf_local_movil: ['', Validators.required],
        correo: ['', Validators.required],
        //--------Datos academicos
        grado_instruccion: ['', Validators.required],
        ultimo_ano: ['', Validators.required],
        password: [''],
        re_password: ['']
    });
  }

  ngOnInit(): void {
    this.srvLogin.user$.subscribe(user => { this.user = user; });
  }

  ngAfterViewInit(): void {
    this.mdl.cargando();
    this.servicios.buscarEstudicante(this.id_estudiante).subscribe({
      next: (rs) => {
        this.mdl.cerrar();

        console.log('datos recojidos:  ',rs)
        this.datosEstudiante = rs.data[0].estudiante;
        this.documentos = rs.data[0].documento;
        this.arrPais = rs.data[0].pais;
        this.arrEstado = rs.data[0].estado;
        this.arrMunicipio = rs.data[0].municipios;
        this.arrParroquia = rs.data[0].parroquia;
        this.arrOperadora = rs.data[0].operadora_local;
        this.arrOperadoraMovil = rs.data[0].operadora_movil;
        this.arrDiscapacidad = rs.data[0].discapacidad;
        this.arrGrupoEtnico = rs.data[0].grupo_etnico;
        this.cmbDiscapacidad = this.datosEstudiante['discapacidad'];
        this.cmbGrupoEtnico = this.datosEstudiante['grupo_etnico'];
        this.tieneHijo = this.datosEstudiante.tiene_hijos;

        console.table('prueba estudiante:   ',rs.data[0].estudiante);
        console.table('prueba documentos:   ',rs.data[0].documento.length);
        //console.table('HOOOOOOOOOOOOO:   ',this.datosEstudiante.telefono_local.split("-")[1]);
        //console.table('aaaaaaaaaaaaaa:   ',this.datosEstudiante.telefono_local.split("-")[0]);


        if (rs.data[0].documento.length > 0) {
          let arr: any[] =[];
          (rs.data[0].documento).forEach((e:any) => {arr.push((e.todo).split("|")[0]) });
          this.valNotas = arr.indexOf('1') == -1 ? null : this.transform(`${this.url}${(rs.data[0].documento[arr.indexOf('1')].todo).split("|")[1]}`);
          this.valConstancia = arr.indexOf('2') == -1 ? null : this.transform(`${this.url}${(rs.data[0].documento[arr.indexOf('2')].todo).split("|")[1]}`);
          this.valFotografia = arr.indexOf('3') == -1 ? null : this.transform(`${this.url}${(rs.data[0].documento[arr.indexOf('3')].todo).split("|")[1]}`);
          this.valCarnet = arr.indexOf('4') == -1 ? null : this.transform(`${this.url}${(rs.data[0].documento[arr.indexOf('4')].todo).split("|")[1]}`);
          this.valCedula = arr.indexOf('5') == -1 ? null : this.transform(`${this.url}${(rs.data[0].documento[arr.indexOf('5')].todo).split("|")[1]}`);
          this.valRepresentante = arr.indexOf('6') == -1 ? null : this.transform(`${this.url}${(rs.data[0].documento[arr.indexOf('6')].todo).split("|")[1]}`);
          this.valSalud = arr.indexOf('7') == -1 ? null : this.transform(`${this.url}${(rs.data[0].documento[arr.indexOf('7')].todo).split("|")[1]}`);
          this.valRif = arr.indexOf('8') == -1 ? null : this.transform(`${this.url}${(rs.data[0].documento[arr.indexOf('8')].todo).split("|")[1]}`);
          this.valCurriculum = arr.indexOf('9') == -1 ? null : this.transform(`${this.url}${(rs.data[0].documento[arr.indexOf('9')].todo).split("|")[1]}`);
          this.valReferencia = arr.indexOf('10') == -1 ? null : this.transform(`${this.url}${(rs.data[0].documento[arr.indexOf('10')].todo).split("|")[1]}`);
          this.valLopna = arr.indexOf('11') == -1 ? null : this.transform(`${this.url}${(rs.data[0].documento[arr.indexOf('11')].todo).split("|")[1]}`);
          arr = [];
          (rs.data[0].documento).forEach((e:any) => {arr.push((e.nombre_pdf).split("|")[0]) });
          this.txtNotas = arr.indexOf('1') == -1 ? 'Cargar .PDF' : (rs.data[0].documento[arr.indexOf('1')].nombre_pdf).split("|")[1]
          this.txtConstancia = arr.indexOf('2') == -1 ? 'Cargar .PDF' : (rs.data[0].documento[arr.indexOf('2')].nombre_pdf).split("|")[1]
          this.txtFotografia = arr.indexOf('3') == -1 ? 'Cargar .PDF' : (rs.data[0].documento[arr.indexOf('3')].nombre_pdf).split("|")[1]
          this.txtCarnet = arr.indexOf('4') == -1 ? 'Cargar .PDF' : (rs.data[0].documento[arr.indexOf('4')].nombre_pdf).split("|")[1]
          this.txtCedula = arr.indexOf('5') == -1 ? 'Cargar .PDF' : (rs.data[0].documento[arr.indexOf('5')].nombre_pdf).split("|")[1]
          this.txtRepresentante = arr.indexOf('6') == -1 ? 'Cargar .PDF' : (rs.data[0].documento[arr.indexOf('6')].nombre_pdf).split("|")[1]
          this.txtSalud = arr.indexOf('7') == -1 ? 'Cargar .PDF' : (rs.data[0].documento[arr.indexOf('7')].nombre_pdf).split("|")[1]
          this.txtRif = arr.indexOf('8') == -1 ? 'Cargar .PDF' : (rs.data[0].documento[arr.indexOf('8')].nombre_pdf).split("|")[1]
          this.txtCurriculum = arr.indexOf('9') == -1 ? 'Cargar .PDF' : (rs.data[0].documento[arr.indexOf('9')].nombre_pdf).split("|")[1]
          this.txtReferencia = arr.indexOf('10') == -1 ? 'Cargar .PDF' : (rs.data[0].documento[arr.indexOf('10')].nombre_pdf).split("|")[1]
          this.txtLopna = arr.indexOf('11') == -1 ? 'Cargar .PDF' : (rs.data[0].documento[arr.indexOf('11')].nombre_pdf).split("|")[1]
        }

        this.cmbDiscapacidad = this.datosEstudiante.discapacidad;
        this.tieneCertificado = this.datosEstudiante.certificado_discapacidad;

        this.formularioRegistro.patchValue({
          //El signo de exclamación(!) se utiliza para afirmar que el valor no es nulo
          nombre: this.datosEstudiante.nombres,
          apellido: this.datosEstudiante.apellidos,
          nro_doc: this.datosEstudiante.tipo_documento,
          documento: this.datosEstudiante.identificacion,
          //fch_nacimiento: this.convierteDtpick(formatDate(new Date(this.datosEstudiante['fecha_nacimiento']), 'dd-MM-yyyy', 'en-US')),
          fch_nacimiento: this.convierteDtpick(formatDate(this.datosEstudiante.fecha_nacimiento, 'dd-MM-yyyy', 'en-US')),
          //edad: this.datosEstudiante['edad'],
          lugar_nacimiento: this.datosEstudiante.lugar_nacimiento,
          id_pais: this.datosEstudiante.id_pais,
          //pais_residencia: this.datosEstudiante['id_pais_residencia'],
          genero: this.datosEstudiante.id_sexo,
          edo_civil: this.datosEstudiante.id_estado_civil,
          tiene_hijos: this.datosEstudiante.tiene_hijos,
          indique_hijos: this.datosEstudiante.indique_hijos > 2 ? '3' : '2',
          discapacidad: this.datosEstudiante.discapacidad,
          indique_discapacidad: this.datosEstudiante.id_discapacidad,

          certificado_discapacidad: this.datosEstudiante.certificado_discapacidad,

          tp_dis: this.datosEstudiante.nconapdis == null ? '' : this.datosEstudiante.nconapdis.split("-")[0],
          numero_discapacidad: this.datosEstudiante.nconapdis == null ? '' : this.datosEstudiante.nconapdis.split("-")[1],
          grupo_etnico: this.datosEstudiante.grupo_etnico,
          indique_etnia: this.datosEstudiante.indique_etnia,

          correo: this.datosEstudiante.correo,
          tipo_operadora: this.datosEstudiante.telefono_local == null ? '' : this.datosEstudiante.telefono_local.split("-")[0],
          tlf_local: this.datosEstudiante.telefono_local == null ? '' : this.datosEstudiante.telefono_local.split("-")[1],
          tipo_operadora_movil: this.datosEstudiante.telefono_movil == null ? '' : this.datosEstudiante.telefono_movil.split("-")[0],
          tlf_local_movil: this.datosEstudiante.telefono_movil == null ? '' : this.datosEstudiante.telefono_movil.split("-")[1],

          estado: this.datosEstudiante['id_estado'],
          municipio: this.datosEstudiante.id_municipio == null ? '' : this.datosEstudiante.id_municipio,
          parroquia: this.datosEstudiante.id_parroquia == null ? '' : this.datosEstudiante.id_parroquia,
          ciudad: this.datosEstudiante['ciudad'],
          sector: this.datosEstudiante['sector'],
          direccion_residencia: this.datosEstudiante.direccion,
          grado_instruccion: this.datosEstudiante['id_nivel_academico'],
          ultimo_ano: this.datosEstudiante['ultimo_ano'],
        });



        this.calcula_edad();


      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }


  // Este método 'transform' ya lo tenías y es correcto,
  // pero asegúrate de llamarlo explícitamente en los lugares donde asignas las URLs.
  transform(url: any): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  ver_pass(tipo: number){
    let pass = tipo == 1 ? (document.getElementById('password') as HTMLInputElement) : (document.getElementById('re_password') as HTMLInputElement);
    pass.getAttribute('type') == 'password' ? pass.setAttribute('type', 'text') : pass.setAttribute('type', 'password');
  }

  hijos(ev: any){
    this.tieneHijo = (ev.target.checked) ? true : false;
    if(!ev.target.checked){
      this.formularioRegistro?.get('indique_hijos')?.setValue('');
      this.formularioRegistro?.get('otros_hijos')?.setValue('');
      this.valida_hijos = false;
    }
  }

  verifica_hijo(ev: any){
    this.formularioRegistro?.get('otros_hijos')?.setValue('');
    this.valida_hijos = ev.target.value == 3 ? true : false;
  }

  convierteDtpick(date: string):NgbDateStruct {
    let array = date.split("-");
    return {year: parseInt(array[2]), month: parseInt(array[1]), day: parseInt(array[0])};
  }

  convertidor(numero: number): string {
    return numero < 10 ? `0${numero}` : numero.toString();
  }

  calcula_edad(){
    const fch_nac = this.formularioRegistro.get('fch_nacimiento')?.value;
    let fch = `${this.convertidor(fch_nac['year'])}-${this.convertidor(fch_nac['month'])}-${this.convertidor(fch_nac['day'])}`
    let fecha1 = new Date(fch);
    let fecha2 = new Date()
    let resta = fecha2.getTime() - fecha1.getTime()
    this.edad = (Math.ceil((Math.round(resta/ (1000*60*60*24)))/365))-1;
    this.formularioRegistro?.get('edad')?.setValue(this.edad);
  }

  municipio(){
    this.mdl.cargando();
    this.servicios.municipio(this.formularioRegistro.get('estado')?.getRawValue()).subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.arrMunicipio = rs.data;
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }

  parroquia(){
    this.mdl.cargando();
    this.servicios.parroquia(this.formularioRegistro.get('municipio')?.getRawValue()).subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.arrParroquia = rs.data;
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }

  validaDiscapacidad(ev: any){
    this.cmbDiscapacidad = ev.target.checked;
    //console.log('target:  ',ev.target.checked)
  }

  validaGrupoEtnico(ev: any){
    this.cmbGrupoEtnico = ev.target.checked;
    //console.log('target:  ',ev.target.checked)
  }

  certificadoDiscapacidad(ev: any){
    this.tieneCertificado = ev.target.checked
  }

  cambia(tipo: number, event: any){
    const input = event.target as HTMLInputElement;
    if(tipo == 1){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          // 1. Crear la URL del objeto
          //this.rawObjectUrl = URL.createObjectURL(input.files[0]1;

          // 2. Sanitizar la URL para que Angular la considere segura
          // Para iframes, usamos bypassSecurityTrustResourceUrl
          this.valNotas = this.transform(URL.createObjectURL(input.files[0]));
          this.txtNotas = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });
          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.datosEstudiante['identificacion'],
            "tipo": tipo,
            "archivo": blob
          }
          //console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));
          console.log('datos a enviar:   ', envio);
          this.subir_archivo(envio);

        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }
    else if(tipo == 2){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          this.valConstancia = this.transform(URL.createObjectURL(input.files[0]));
          this.txtConstancia = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });
          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.datosEstudiante['identificacion'],
            "tipo": tipo,
            "archivo": blob
          }
          this.subir_archivo(envio);
          console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));
        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }
    else if(tipo == 3){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          this.valFotografia = this.transform(URL.createObjectURL(input.files[0]));
          this.txtFotografia = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });
          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.datosEstudiante['identificacion'],
            "tipo": tipo,
            "archivo": blob
          }
          this.subir_archivo(envio);
          console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));

        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }
    else if(tipo == 4){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          this.valCarnet = this.transform(URL.createObjectURL(input.files[0]));
          this.txtCarnet = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });
          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.datosEstudiante['identificacion'],
            "tipo": tipo,
            "archivo": blob
          }
          this.subir_archivo(envio);
          console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));

        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }
    else if(tipo == 5){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          this.valCedula = this.transform(URL.createObjectURL(input.files[0]));
          this.txtCedula = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });
          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.datosEstudiante['identificacion'],
            "tipo": tipo,
            "archivo": blob
          }
          this.subir_archivo(envio);
          console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));

        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }
    else if(tipo == 6){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          this.valRepresentante = this.transform(URL.createObjectURL(input.files[0]));
          this.txtRepresentante = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });
          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.datosEstudiante['identificacion'],
            "tipo": tipo,
            "archivo": blob
          }
          this.subir_archivo(envio);
          console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));

        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }
    else if(tipo == 7){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          this.valSalud = this.transform(URL.createObjectURL(input.files[0]));
          this.txtSalud = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });
          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.datosEstudiante['identificacion'],
            "tipo": tipo,
            "archivo": blob
          }
          this.subir_archivo(envio);
          console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));

        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }
    else if(tipo == 8){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          this.valRif = this.transform(URL.createObjectURL(input.files[0]));
          this.txtRif = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });
          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.datosEstudiante['identificacion'],
            "tipo": tipo,
            "archivo": blob
          }
          this.subir_archivo(envio);
          console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));

        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }
    else if(tipo == 9){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          this.valCurriculum = this.transform(URL.createObjectURL(input.files[0]));
          this.txtCurriculum = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });
          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.datosEstudiante['identificacion'],
            "tipo": tipo,
            "archivo": blob
          }
          this.subir_archivo(envio);
          console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));

        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }
    else if(tipo == 10){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          this.valReferencia = this.transform(URL.createObjectURL(input.files[0]));
          this.txtReferencia = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });
          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.datosEstudiante['identificacion'],
            "tipo": tipo,
            "archivo": blob
          }
          this.subir_archivo(envio);
          console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));

        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }
    else if(tipo == 11){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          this.valLopna = this.transform(URL.createObjectURL(input.files[0]));
          this.txtLopna = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });
          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.datosEstudiante['identificacion'],
            "tipo": tipo,
            "archivo": blob
          }
          this.subir_archivo(envio);
          console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));

        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }

  }

  subir_archivo(datos: any){
    this.servicios.subir_archivo(datos).subscribe({
      next: (rs) => {
        console.log('aaaaa:   ',rs)
        if(rs.data == 0){
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = `Este archivo (${datos.nombre_archivo}) ya existe.`;
          this.mdl.alerta();
          if(datos.tipo == 1){
            this.valNotas = null;
          }
          else if(datos.tipo == 2){
            this.valConstancia = null;
          }
          else if(datos.tipo == 3){
            this.valFotografia = null;
          }
          else if(datos.tipo == 4){
            this.valCarnet = null;
          }
          else if(datos.tipo == 5){
            this.valCedula = null;
          }
          else if(datos.tipo == 6){
            this.valRepresentante = null;
          }
          else if(datos.tipo == 7){
            this.valSalud = null;
          }
          else if(datos.tipo == 8){
            this.valRif = null;
          }
          else if(datos.tipo == 9){
            this.valCurriculum = null;
          }
          else if(datos.tipo == 10){
            this.valReferencia = null;
          }
          else if(datos.tipo == 11){
            this.valLopna = null;
          }
        }
        else{
          this.titulo = '!EXITO¡';
          this.tipo_color = 'success';
          this.letra_color = 'light';
          this.mensaje = 'Archivo cargado con exito.';
          this.mdl.alerta();
        }
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }

  guardar_todo(){

    let passRegex = /^(?=.*[!@#$%^&*(),.?":{}|<>])(?=.*\d)(?=.*[a-z]).{8,}$/;
    let emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
    let pass = this.formularioRegistro.get('password')?.getRawValue();
    let mail = this.formularioRegistro.get('correo')?.getRawValue();
    let valor: boolean = true;
    if(!this.formularioRegistro.valid){
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = "Debe completar los campos requeridos del formulario (*)";
      this.mdl.alerta();
      valor = false;
    }
    else if(pass != '' || this.formularioRegistro.get('re_password')?.getRawValue() != ''){
      if(!passRegex.test(pass)){
        this.titulo = '!ADVERTENCIA¡';
        this.tipo_color = 'warning';
        this.letra_color = 'dark';
        //this.mensaje = "La contraseña no cumple con las características de validación. Por favor presione el botón de ('Indicaciones para crear la contraseña...') ";
        this.mensaje = "La contraseña no cumple con las características de validación.";
        this.mdl.alerta();
        valor = false;
      }else if(pass != this.formularioRegistro.get('re_password')?.getRawValue()){
        this.titulo = '!ADVERTENCIA¡';
        this.tipo_color = 'warning';
        this.letra_color = 'dark';
        this.mensaje = "Las contraseñas deben ser iguales";
        this.mdl.alerta();
        valor = false;
      }
      else{
        valor = true;
      }
    }
    else if(!emailRegex.test(mail)){
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      //this.mensaje = "La contraseña no cumple con las características de validación. Por favor presione el botón de ('Indicaciones para crear la contraseña...') ";
      this.mensaje = "Por favor ingrese un correo válido.";
      this.mdl.alerta();
      valor = false;
    }
    else{
      valor = true;
    }


    if(valor){

      //aplica solo caundo se va a enviar en vista de que si no se ejecuta el
      //servicio da error ya que modificamos las variables del formGroup
      let val1 = this.formularioRegistro.get('tp_dis')?.getRawValue();
      let val2 = this.formularioRegistro.get('numero_discapacidad')?.getRawValue();
      let combinado = `${val1}-${val2}`;
      let fch_nac = this.formularioRegistro.get('fch_nacimiento')?.getRawValue();
      let fch = `${this.convertidor(fch_nac['year'])}-${this.convertidor(fch_nac['month'])}-${this.convertidor(fch_nac['day'])}`
      this.formularioRegistro.get('fch_nacimiento')?.setValue(fch);
      Object.assign(this.formularioRegistro.value, {'id_estudiante': this.datosEstudiante['id_estudiante']});
      (this.formularioRegistro.value).numero_discapacidad = combinado;
      console.log('todos: ', this.formularioRegistro.value)
      this.mdl.cargando();
      this.servicios.updateEstudiante(this.formularioRegistro.value).subscribe({
        next: (rs) => {
          this.mdl.cerrar();
          this.vuelve.emit({value: false, validador: true});
        },
        error: (error) => {
          this.errorMessage = error.message; // Muestra el mensaje de error al usuario
          //console.error("Error en el componente:", error); // Registro del error en el componente
        }
      });


    }

  }


  volver(){
    this.vuelve.emit({value: false, validador: false});
  }

}
